export default "__VITE_ASSET__Cdw2k6ut__"